var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecuritySafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9488 21.7765V13.1794C40.9488 11.5735 39.7346 9.7523 38.2267 9.14521L27.3188 4.68021C24.8709 3.68146 22.1096 3.68146 19.6617 4.68021L8.75377 9.14521C7.26544 9.7523 6.05127 11.5735 6.05127 13.1794V21.7765C6.05127 31.3527 13.0034 40.3219 22.5013 42.946C23.1475 43.1223 23.8525 43.1223 24.4988 42.946C33.9967 40.3219 40.9488 31.3527 40.9488 21.7765ZM24.9688 25.2035V30.354C24.9688 31.1569 24.3029 31.8227 23.5 31.8227C22.6971 31.8227 22.0313 31.1569 22.0313 30.354V25.2035C20.0534 24.5769 18.6042 22.736 18.6042 20.5623C18.6042 17.8598 20.7975 15.6665 23.5 15.6665C26.2025 15.6665 28.3959 17.8598 28.3959 20.5623C28.3959 22.7556 26.9467 24.5769 24.9688 25.2035Z",
    fill: "#2CC7A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.ba9642bc.svg";
export { ForwardRef as ReactComponent };